import { ChangeDetectorRef, Component, EventEmitter, HostListener, OnInit, Output } from "@angular/core";
import { FileOperationsController } from "@commoncore/controller/FileOperationsController";
import { GlobalService } from "@commoncore/services/global.service";
import { AppEvents } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { DependenciesModule } from "@modules/dependencies/dependencies.module";


@Component({
  standalone:true,
  selector: "app-delete-items",
  templateUrl: "./delete-items.component.html",
  styleUrls: ["./delete-items.component.scss"],
  imports:[DependenciesModule]
})
export class DeleteItemsComponent implements OnInit {
  // @Output() close = new EventEmitter();
  @Output() close = new EventEmitter();
  @Output() confirmDeletion = new EventEmitter();
  universalService: any;
  controller: any;
  implRef: any;
  listService: any;
  currentRoute:any;
  showDeleteModal: boolean = false;
  
  filesNotOwnedByUser:any =[];
  constructor(public globalService: GlobalService,
    private changeDetector:ChangeDetectorRef) {
    this.setEnvObjects(globalService);
  }
  
  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.showDeleteModal) {
      this.listService.deSelectAll(event)
    }else if(event.key === "Enter" && this.showDeleteModal){
      this.deleteItem()
    }
  }

  ngOnInit(): void {
    let classRef = this;
    this.controller = FileOperationsController.getInstance(this.globalService);
    this.implRef = this.controller.fileOperationsImplementation;
    this.controller.setEnvObjects(this.globalService);
    AppEvents.optionSelected.subscribe(event => {
      console.log("delete", event)
      if(event["delete"]){
        classRef.findOwner();
        classRef.showDeleteModal = event["delete"];
        classRef.initializeComponent();
        classRef.changeDetector.detectChanges();
      } else if(event["closeAll"]){
        classRef.showDeleteModal = false;
        classRef.changeDetector.detectChanges();
      }
     })
   
  }

  subscriptiontoDeleteEvent(){
    AppEvents.optionSelected.subscribe(event => {
     console.log("delete", event)
    })
  }


  initializeComponent(){
    var url = window.location.href;
    if(url.includes('sharedwithme')){
      this.currentRoute = "sharedwithme"
    } else if(url.includes('sharedbyme')){
        this.currentRoute = "sharedbyme"
    }
  }
  setEnvObjects(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
  }

  closePopUp(){
    this.universalService.popUpToBeOpened = "";
    this.universalService.openMoreOptions = false;
    this.universalService.showMobOptionMenu = false;
    this.showDeleteModal = false;
    // this.changeDetector.detectChanges();
    this.close.emit();
  }

  deleteItem(){
    this.filterTheObjectsWhichShouldBeDeleted();
    this.universalService.selectedNodes.map(function(obj){
      if(obj["FullObject"]){
        obj["FullObject"]["status"] = "T";
      }else{
      obj["status"] = "T";
      }
    })
    var object = {
      "files":this.universalService.selectedNodes,
      "operation":"TRASH",
      "correlationId": USER_DETAILS["USER_DETAILS"]["userId"]
    }
    $('.docEditFrameCont').addClass('hide');
    this.confirmDeletion.emit(object);
    // const filesDeletedCount = this.universalService.selectedNodes.length;
    // const deleteSuccessfulMsg = filesDeletedCount + (filesDeletedCount > 1? ' item(s)' : ' item' )+ ' deleted successfully';  
    // this.universalService.showToast(deleteSuccessfulMsg, 'success');
    // jQuery("[class*='modal-backdrop']").remove();
  }

  findOwner(){
    if(this.universalService.selectedTab != "Album Details"){
      return;
    }
    var classRef = this;
    classRef.filesNotOwnedByUser = [];
    this.universalService.selectedNodes.map((obj,index)=>{
      obj = obj["FullObject"]?obj["FullObject"]:obj
      if((obj["isLoggedInUsrFileOwner"] ==  false && obj["isLoggedInUsrAlbumOwner"] ==  false)){
        classRef.filesNotOwnedByUser.push(obj);
      }
    })
    console.log("filtered delete array", classRef.filesNotOwnedByUser,this.universalService.selectedNodes)
  }

  filterTheObjectsWhichShouldBeDeleted(){
    if(this.universalService.selectedTab != "Album Details"){
      return;
    }
    var classRef = this;
    classRef.filesNotOwnedByUser.map(obj=>{
      classRef.universalService.selectedNodes.map((object,index)=>{
        object = object["FullObject"]?object["FullObject"]:object
        if(obj["objectKey"] == object["objectKey"]){
          classRef.universalService.selectedNodes.splice(index,1)
        }
      })
    })
    console.log("delete array",this.universalService.selectedNodes)
  }
}
